import React,{useState} from "react"
import { AppForm } from 'components/AppFormLayout/AppForm'
import {ParamTabsData}  from './ParamEditData'
import api, { AppParam } from "api"
import AppDialog from "components/AppDialog"
import { message } from "antd"

interface Props{
    mode?:number;
    id?:number;
    customerData?:any
    scope?:any
    application?:any
    groupId?:any
    afterSave:()=>void
}

export const ParamEdit = (props:Props) =>{

    const appFormRef = React.useRef()
    const saveParam= async ()=>{
        if (typeof appFormRef.current === 'undefined') {
			return
		}
        // tslint:disable-next-line: no-shadowed-variable
        let formData = (appFormRef.current as any).getFormData()
        let appParam =Object.assign(props.customerData?props.customerData:{
            application:props.application,scope:props.scope,groupId:props.groupId
          },formData)as AppParam    
        let res = await api.modeling.param.saveParam(appParam)
        if(res.result){
            message.success('保存成功！')
            close();
            props.afterSave();
        }else{
            message.error(res.msg)
        }
        }

        const close=()=>{
            AppDialog.close();
        }

    const FormActionData = [
        { title: '保存', id: 'btnSave', type: 'primary',action:saveParam},
        { title: '取消', id: 'btnCancel', type: 'default' },
    ]

    return (<AppForm
        defaultTabId={0}
        appFormTabList={ParamTabsData}
        appFormActionList={FormActionData}
        mode={props.mode}
        ref={appFormRef}
        customerData={props.customerData}
    ></AppForm>
    )
}


// WEBPACK FOOTER //
// ./src/modules/modeling/param/components/ParamEdit.tsx